/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { changeCurrentPage } from '../../../../general_redux/actions';
import UserImg from '../../../../icons/default_avatar.jpg';
import { fetchUserProfile, editUser } from '../redux/actions';
import style from './Profile.module.scss';
import editIcon from '../../../../icons/editIcon.svg';

const ProfileView = ({
  actionFetchUserProfile,
  actionUpdateCurrentPage,
  profile,
  history
}) => {
  useEffect(() => {
    actionFetchUserProfile();
    actionUpdateCurrentPage('Airport Portal');
  }, []);

  return (
    <>
      <div className={style.ContainersProfile}>
        <div className={style.ContainerNew}>
          <div className={style.boxesNew}>
            <div className={style.Details}>
              <div className={style.detailsPage}>
                <span className={style.Name}>{profile?.current_tenant?.name}</span>
                <span className={style.PositionTitle}>{profile?.job_function?.[0]?.name}</span>
              </div>
            </div>
          </div>

          {/* box 0 */}
          <div className={style.companyBox}>
            <div className={style.CompanyDetails1}>
              <div className={style.company}>
                <span className={style.Name}>
                  <FormattedMessage
                    id="profile.info.COMPANY DETAILS"
                    defaultMessage="COMPANY DETAILS"
                  />
                </span>
              </div>
              {/* Box 1 */}
              <div className={style.detailsPages}>
                <span className={style.Names}>
                  <FormattedMessage
                    id="profile.info.ADDRESS"
                    defaultMessage="ADDRESS"
                  />
                </span>
                <span className={style.CompanyName1}>
                  {[profile?.current_tenant?.updated_address?.[0]?.street, profile?.current_tenant?.updated_address?.[0]?.city,
                 profile?.current_tenant?.updated_address?.[0]?.state, profile?.current_tenant?.updated_address?.[0]?.zip].filter(Boolean)?.join(', ')}
                </span>
              </div>
              {/* Box 2 */}
              <div className={style.detailsPages}>
                <span className={style.Names}>
                  <FormattedMessage
                    id="profile.info.phone"
                    defaultMessage="PHONE"
                  />
                </span>
                <span className={style.CompanyName1}>{profile?.current_tenant?.phone}</span>
              </div>
              {/* Box 3 */}
              <div className={style.detailsPages}>
                <span className={style.Names}>
                  <FormattedMessage
                    id="profile.info.email"
                    defaultMessage="EMAIL"
                  />
                </span>
                <span className={style.CompanyName1}>{profile?.current_tenant?.email}</span>
              </div>
              {/* Box 4 */}
              <div className={style.detailsPages}>
                <span className={style.Names}>
                  <FormattedMessage
                    id="profile.info.BUSINESS TYPE"
                    defaultMessage="BUSINESS TYPE"
                  />
                </span>
                <span className={style.CompanyName1}>{profile?.current_tenant?.business_type}</span>
              </div>
              {/* box5 */}
              <div className={style.detailsPages}>
                <span className={style.Names}>
                  <FormattedMessage
                    id="profile.info.CATEGORY"
                    defaultMessage="CATEGORY"
                  />
                </span>
                <span className={style.CompanyName1} style={{ padding: '0px 0px 12px' }}>{profile?.current_tenant?.category}</span>
              </div>
            </div>
          </div>
        </div>
        <div className={style.ContainerNew}>
          <div className={style.contactDetails}>
            <div className={style.contactDetailsPage}>
              <span className={style.Name}>Contact Details</span>
              <span className={style.editIcon}>
                <img
                  src={editIcon}
                  onClick={() => { history.push('profile/edit'); }}
                  onKeyDown={() => { history.push('profile/edit'); }}
                  alt="editIcon"
                  aria-hidden
                />
              </span>
            </div>
          </div>
          <div className={style.Profiles}>
            <div className={style.upper}>
              <div className={style.Logs}>
                <img
                  src={profile.image ? profile.image : UserImg}
                  className={style.ProfileLogo}
                  alt={profile.fullname}
                />
              </div>
              <div className={style.details}>
                <span className={style.Name}>{profile?.fullname}</span>
                <span className={style.PositionTitle}>{profile?.job_function?.[0]?.name}</span>
              </div>
            </div>
            <div className={style.lower}>
              <div className={style.lowerbox}>
                <div>
                  <span>
                    <FormattedMessage
                      id="profile.info.email"
                      defaultMessage="EMAIL"
                    />
                  </span>
                </div>
                <div className={style.email}>
                  <span>{profile.user.email}</span>
                </div>
              </div>
              <div className={style.lowerboxes}>
                <div>
                  <span>
                    <FormattedMessage
                      id="profile.info.phone"
                      defaultMessage="PHONE"
                    />
                  </span>
                </div>
                <div className={style.phoneNumber}>
                  <span>{profile.phone}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ProfileView.propTypes = {
  profile: PropTypes.shape({}).isRequired,
  actionFetchUserProfile: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  // Fetch airport
  actionFetchUserProfile: () => {
    dispatch(fetchUserProfile());
  },
  actionEditUserProfile: (data) => {
    dispatch(editUser(data));
  },
  actionUpdateCurrentPage: (page) => {
    dispatch(changeCurrentPage(page));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ProfileView));
